export default __webpack_public_path__ + "static/media/27.fcc8f882.png";